import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tsu-home-slider',
  templateUrl: './home-slider.component.html',
  styleUrls: ['./home-slider.component.scss']
})
export class HomeSliderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
